import { html } from "lit";
var icon_financial_default = () => html`
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero">
      <path
        d="M19 9.125a.875.875 0 0 1 .11 1.743l-.11.007h-4.065a1.809 1.809 0 0 0-.814 3.424l.138.063 4.13 1.652a3.559 3.559 0 0 1-1.139 6.856l-.188.005H13a.875.875 0 0 1-.11-1.743l.11-.007h4.061a1.809 1.809 0 0 0 .814-3.424l-.138-.063-4.13-1.652a3.559 3.559 0 0 1 1.139-6.856l.188-.005H19Z" />
      <path
        d="M16 7.625c.446 0 .814.334.868.765l.007.11V10a.875.875 0 0 1-1.743.11l-.007-.11V8.5c0-.483.392-.875.875-.875Z" />
      <path
        d="M16 21.125c.446 0 .814.334.868.765l.007.11v1.5a.875.875 0 0 1-1.743.11l-.007-.11V22c0-.483.392-.875.875-.875Z" />
      <path
        d="M16 3.125C8.89 3.125 3.125 8.889 3.125 16c0 7.11 5.764 12.875 12.875 12.875 7.11 0 12.875-5.764 12.875-12.875 0-7.11-5.764-12.875-12.875-12.875Zm0 1.75c6.144 0 11.125 4.98 11.125 11.125 0 6.144-4.98 11.125-11.125 11.125-6.144 0-11.125-4.98-11.125-11.125C4.875 9.856 9.855 4.875 16 4.875Z" />
    </g>
  </svg>
`;
export {
  icon_financial_default as default
};
//# sourceMappingURL=icon-financial.js.map
